export enum PersonalIdentityNumberFeature {
  StralkastarenRegistration = 'stralkastarenregistration',
  DelayCompensation = 'delaycompensation',
  Reclamation = 'reclamation',
  Refund = 'refund',
  CreatePrivateCustomerAccount = 'createprivatecustomeraccount',
}
